import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiRemoveAppUserResponseBody } from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appUserQueryKeyFactory } from './useAppUserQuery';
import { appUsersQueryKeyFactory } from './useAppUsersQuery';

export type IUseDeleteAppUserMutationValues = {
  appId: string;
  userId: string;
};

export const useRemoveAppUserMutation = (): UseMutationResult<
  IApiRemoveAppUserResponseBody,
  unknown,
  IUseDeleteAppUserMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteAppUserMutationValues) =>
      api.apps.removeUser(values.appId, values.userId),
    onSuccess: async (data, values) => {
      data.deletedResources.userIds
        .map((userId) => [
          { queryKey: appUserQueryKeyFactory({ ...values, userId }) },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: appUsersQueryKeyFactory(values),
      });
    },
  });
};
